


















































import {Component, Mixins, Watch} from 'vue-property-decorator';
import EditDialogMixin from '@/mixins/dialog/EditDialogMixin';
import CEditDialog from '@/components/base/dialog/CEditDialog.vue';
import CSimpleTable from '@/components/base/table/CSimpleTable.vue';
import CTextField from '@/components/base/textField/CTextField.vue';
import CSelect from '@/components/base/select/CSelect.vue';
import CDatepicker from '@/components/base/datepicker/CDatepicker.vue';
import CTable from '@/components/base/table/CTable.vue';
@Component({
    components: {CTable, CDatepicker, CSelect, CTextField, CSimpleTable, CEditDialog},
})
export default class ScheduleGenerateDialog extends Mixins(EditDialogMixin) {
    private datePeriod: Array<string> = [];

    get datePickerMin() {
        return new Date(this.data?.allowDates[0]).toISOString().substr(0, 10);
    }

    get datePickerMax() {
        let dates = this.data?.allowDates;
        return new Date(dates[dates.length - 1]).toISOString().substr(0, 10);
    }

    get tableHeaders() {
        return [
            {
                value: 'Name',
                text: this.$t('Common.Name'),
            },
            {
                value: 'IdShiftTml',
                text: this.$t('Catalogues.ShiftTml.NameSingle'),
                sort: this.getDescriptionsContainer().getSortFn(
                    this.addDescriptionPostfix(this.$api.catalogues.shiftTml),
                ),
            },
        ];
    }

    @Watch('datePeriod')
    onDatePeriodChange(value: Array<string>) {
        let parsedValue = value.map(item => Date.parse(item));
        if (parsedValue[0] > parsedValue[1]) this.datePeriod = value.reverse();
        else if (this.data) this.data.datePeriod = parsedValue;
    }

    init(data: any) {
        this.data = {
            daySchedule: data.DaySchedule,
            allowDates: data.AllowDates,
            datePeriod: [],
        };
        this.datePeriod = [this.datePickerMin, this.datePickerMax];
    }

    beforeSave() {
        if (this.data.datePeriod.length === 1) this.data.datePeriod = this.data.datePeriod.concat(this.data.datePeriod);
    }

    datePickerTitleDateFormat(dates: Array<string>) {
        return dates
            .map(item =>
                new Date(item).toLocaleString(this.$i18n.locale, {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                }),
            )
            .join(' ~ ');
    }

    dateIsAllowed(date: string) {
        let parsedDate = Date.parse(date);
        return this.data.allowDates.includes(parsedDate);
    }
}
